import { Pipe, PipeTransform } from '@angular/core';

import { TimeTrackingsTask } from '@models/time-trackings-task';

@Pipe({
  name: 'timeTrackingTaskLabel',
  standalone: true
})
export class TimeTrackingTaskLabelPipe implements PipeTransform {
  transform(timeTrackingTask: TimeTrackingsTask): string | null {
    if (!timeTrackingTask) {
      return null;
    }

    let timeTrackingLabel = '';
    if (timeTrackingTask.code) {
      timeTrackingLabel = timeTrackingLabel.concat(`${timeTrackingTask.code} • `);
    }

    return timeTrackingLabel.concat(timeTrackingTask.wording);
  }
}
